import { NgModule } from '@angular/core';
import { profileGuard } from './guards/profile-guard';
import { AuthErrorComponent } from './components/auth-error/auth-error.component';
import { authGuard } from './auth/guards/auth.guard';
import { HealthComponent } from './components/health/health.component';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
  scrollOffset: [0, 64],
};

const routes: Routes = [
  {
    path: 'main',
    loadChildren: () => import('./logged-module/logged.module').then((m) => m.LoggedModule),
    canActivate: [authGuard, profileGuard],
  },
  {
    path: 'login-error',
    component: AuthErrorComponent,
    data: { scenario: 'relay' },
  },
  {
    path: 'auth-error',
    component: AuthErrorComponent,
    data: { scenario: 'session' },
  },
  {
    path: 'etm-account-inactive',
    component: AuthErrorComponent,
    data: { scenario: 'etm-account-inactive' },
  },
  {
    path: 'product-entitlement-inactive',
    component: AuthErrorComponent,
    data: { scenario: 'product-entitlement-inactive' },
  },
  {
    path: 'health',
    component: HealthComponent,
  },
  {
    path: 'sso',
    loadChildren: () => import('./sso/sso.module').then((m) => m.SsoModule),
  },
  { path: '**', redirectTo: 'main', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
